<template lang='pug'>
  div.search-box(v-show="label")
    span.s-span 查找 {{label}} 中包含“{{content}}”
    //- input.s-input(v-model="keyword" ref="searchBox" placeholder="表格内搜索")
    //- div.count(v-show="keyword!=''") {{count}} of {{total}}
    //- button.s-btn(@click="search") 搜索
    button.s-btn(@click="prev")
      i.el-icon-arrow-up.
    button.s-btn(@click="next")
      i.el-icon-arrow-down
    button.s-btn(@click="doClose")
      i.el-icon-close
</template>

<script>
// Generated by CoffeeScript 2.3.0
var m;

export default m = {
  data: function() {
    return {
      label: '',
      content: '',
      count: Number,
      total: Number,
      rv: null,
      result: [],
      current: -1
    };
  },
  methods: {
    // focus: ->
    //   @$refs.searchBox.focus()
    textHighlight: function(el) { //TBD
      var child, k, ref, results;
      if (el == null) {
        el = this.rv.$el;
      }
      // console.log el.tagName, el.childNodes
      if (el.innerText) {
        return console.log(el.tagName, el.innerText);
      } else {
        ref = el.childNodes;
        results = [];
        for (k in ref) {
          child = ref[k];
          results.push(this.textHighlight(child));
        }
        return results;
      }
    },
    search: function(col, content) {
      var re, result;
      this.col = col;
      this.content = content;
      this.isShow = true;
      this.label = this.rv.shownColumns[this.col].label;
      re = new RegExp(this.content, "gim");
      result = [];
      this.rv.data.map((item, row) => {
        var value;
        value = item[this.label];
        if (this.label !== '_id' && typeof value === 'string') {
          if (re.test(value)) {
            return result.push({row, col: this.col, label: this.label, value, item});
          }
        }
      });
      this.result = result;
      if (this.result.length > 0) {
        // @textHighlight()
        return this.go(0);
      } else {
        return this.result = [];
      }
    },
    go: function(k) {
      var res, ypos;
      res = this.result[k];
      ypos = res.row * 29 - 100;
      this.current = k;
      this.rv.dishighlight();
      this.rv.scrollFrame(0, ypos);
      this.rv.setStatus(`第${this.current + 1}/${this.result.length}条记录`);
      return this.rv.highlight(res.row, res.col, false);
    },
    // @rv.updateDone =>
    //   @rv.highlight res.row, res.col, false
    next: function() {
      if (this.result.length === 0) {
        return;
      }
      if (this.current < this.result.length - 1) {
        return this.go(this.current + 1);
      } else {
        return this.go(0);
      }
    },
    prev: function() {
      if (this.result.length === 0) {
        return;
      }
      if (this.current > 0) {
        return this.go(this.current - 1);
      } else {
        return this.go(this.result.length - 1);
      }
    },
    doClose: function() {
      this.label = '';
      return this.content = '';
    }
  },
  watch: {
    keyword: function(val) {
      return this.search(val);
    }
  },
  mounted: function() {
    this.rv = this.$parent;
    
    // console.log @data
    return this.opts = this.rv.opts;
  }
};

// window.onkeydown = (e) =>
//   if e.ctrlKey
//     if e.key == 'f'
//       e.preventDefault()
//       @isShow = true
//       @focus()
</script>
